// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 访问修饰符枚举 枚举类
 * 定义类、属性、方法等访问修饰符
 */
export enum EnumAccessModifier {
  /** 公开的 : 公开的 */
  Public = 1,
  /** 私有的 : 私有的 */
  Private = 2,
  /** 受保护的 : 受保护的 */
  Protected = 4,
  /** 内部的 : 内部的 */
  Internal = 8,
  /** 内部受保护的 : 内部受保护的 */
  ProtectedInternal = 16
}

/**
 * 访问修饰符枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumAccessModifierMD {
  private static items = [
    new EnumItemMD('Public', 1, '公开的', '公开的'),
    new EnumItemMD('Private', 2, '私有的', '私有的'),
    new EnumItemMD('Protected', 4, '受保护的', '受保护的'),
    new EnumItemMD('Internal', 8, '内部的', '内部的'),
    new EnumItemMD('ProtectedInternal', 16, '内部受保护的', '内部受保护的')
  ];

  static getItem(enumItem: EnumAccessModifier) {
    return this.items.find(item => item.name === EnumAccessModifier[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
